const selectLoading = (state) => state.data.loading;

export default selectLoading;
